import React, { createContext, useContext, useState, useRef, useEffect } from "react"
import { ChevronDown } from "lucide-react"
import { useOnClickOutside, useIntersectionObserver } from 'usehooks-ts'
import { useClickOutside } from "lib/hooks/useClickOutside"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"

const MenuContext = createContext<any>(null)
export const useMenuCtx = () => useContext(MenuContext)


export function MenuItem({ label, type, isSelected, selectFn, visibleFn, pos, children }:any){

  const { openMenu, setOpenMenu } = useMenuCtx()

  const [ showItem, setShowItem ] = useState<boolean>(true) 

  const handleSelect = () => {
    if( type === "option" && selectFn !== undefined ){
      setOpenMenu("")
      selectFn()
    }
  }

  useEffect(() => {
    if( visibleFn !== undefined ){
      setShowItem(visibleFn())
    }
  },[visibleFn])

  if( !showItem ) return <></>
  return (
    <div 
      onClick={handleSelect}
      className={cn(
        "menu-item",
        "w-full flex justify-start items-center pr-3 py-1 whitespace-nowrap hover:bg-teal-800",
        pos === "last" && "border-b-0",
        type === "divider" && "mt-1 w-[96%] mx-auto border-t border-t-solid border-t-slate-700/70 border-b-0",
        type === "option" && selectFn === undefined && "cursor-not-allowed bg-slate-700 pl-2",
        type === "option" && selectFn !== undefined && "cursor-pointer hover:bg-green-800 pl-3",
        isSelected && "text-green-700",
      )}
    >
      { type === "option" &&  label }
    </div>
  )
}

export function Menu({
  menu,
  className=""
}:{
  menu:any
  className?:string
}){

  const ref = useRef(null)
  const { config, openMenu, setOpenMenu } = useMenuCtx()

  const handleClickInside = () => {
    console.log('clicked inside')
    return false
  }
 

  if( menu.visibleFn !== undefined && !menu.visibleFn() ) return <></>
  return (
    <div className={cn("flex items-center relative cursor-pointer", className)}>
      <div 
        ref={ref}
        className="w-full flex justify-start items-center gap-2 pl-2" 
        onClick={() => setOpenMenu(openMenu === menu.refstr ? "" : menu.refstr)}
      >
        <div 
          className="text-xs uppercase" 
        >
          { menu.label }
        </div> 
        { menu.submenus && (
          <ChevronDown className="w-3 h-3 stroke-1 cursor-pointer" />
        )}
      </div>
      { menu.submenus && (
        <div 
          onClick={handleClickInside}
          className={cn(
            "absolute z-20 bg-slate-900 top-7 left-0 min-w-[20px] min-h-6 py-[2px] px-[2px] border border-solid border-slate-600 whitespace-nowrap break-keep *:text-xs", 
            config?.size === "lg" && "py-[4px] min-h-10 *:text-sm",
            openMenu === menu.refstr ? "block" : "hidden",
            menu.edge === "right" && "left-auto right-0"
          )}
        >
          { menu.submenus.map((submenu:any, idx:number) => (
            <MenuItem 
              key={idx}
              pos={ menu.submenus.length > 1 && idx === 0 ? "first" : idx === menu.submenus.length - 1 ? "last" : "middle"} 
              {...submenu} 
            />
          ))}
        </div>
      )}
    </div>
  )
}

export function Menubar({
  config,
  menus,
  defaultAction,
  className=""
}:{
  config?:any,
  menus:any[],
  defaultAction?:any,
  className?:string
}){

  const menuref = useRef(null)
  const [ openMenu, setOpenMenu ] = useState<string>("")

  const handleClickOutside = (e:any) => {
    if( !openMenu ) return false
    if( !e.target.classList.contains("menu-item") ){
      setOpenMenu("")
    }
  }
  
  useOnClickOutside(menuref, handleClickOutside)

  useEffect(() => {
    if( defaultAction !== undefined ){
      defaultAction()
    }
  },[defaultAction])

  return (
    <MenuContext.Provider value={{ config, openMenu, setOpenMenu }}>
      <div ref={ openMenu ? menuref : null} className={cn("w-full h-full flex justify-start items-center", className)}>
        {menus !== undefined && menus.map((menu:any, idx:number) => (
          <Menu key={idx} menu={menu} />
        ))}
      </div>
    </MenuContext.Provider>
  )
}